import { render, staticRenderFns } from "./AusterButton.vue?vue&type=template&id=1dbce9d8&scoped=true&"
import script from "./AusterButton.vue?vue&type=script&lang=ts&"
export * from "./AusterButton.vue?vue&type=script&lang=ts&"
import style0 from "./AusterButton.vue?vue&type=style&index=0&id=1dbce9d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbce9d8",
  null
  
)

export default component.exports